export function isNotNumericKey(key) {
  return /[^\d|.]/.test(key) && key.length === 1;
}
